import { render, staticRenderFns } from "./ResponsibilityDirectoryView.vue?vue&type=template&id=685139b5&scoped=true"
import script from "./ResponsibilityDirectoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityDirectoryView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityDirectoryView.vue?vue&type=style&index=0&id=685139b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685139b5",
  null
  
)

export default component.exports